import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import api from '../services/api';
import AlertBanner from '../components/AlertBanner';
import Footer from '../components/Footer';
import './Help.css';

const Help: React.FC = () => {
  const [formData, setFormData] = useState({
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.subject.trim() || !formData.message.trim()) {
      setError('Please fill in all fields');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      await api.post('/api/support/contact', {
        subject: formData.subject,
        message: formData.message
      });

      setSuccess(true);
      setFormData({ subject: '', message: '' });
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="help-page-container">
      {success && (
        <AlertBanner
          message="Message sent successfully! We'll get back to you soon."
          type="success"
          onClose={() => setSuccess(false)}
          autoClose={true}
          autoCloseDelay={5000}
        />
      )}
      <Container fluid className="py-4 help-page">
        <Row className="justify-content-center">
          <Col>
            <h1>help</h1>
            <p className="lead">get in touch with our support team.</p>

            {error && (
              <Alert variant="danger" dismissible onClose={() => setError('')}>
                {error}
              </Alert>
            )}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Subject</Form.Label>
                <Form.Control
                  type="text"
                  name="subject"
                  placeholder="What topic is this regarding?"
                  value={formData.subject}
                  onChange={handleInputChange}
                  disabled={loading}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={6}
                  name="message"
                  placeholder="Type your message here"
                  value={formData.message}
                  onChange={handleInputChange}
                  disabled={loading}
                  required
                />
              </Form.Group>

              <div className="d-grid gap-2">
                <Button
                  type="submit"
                  variant="primary"
                  disabled={loading || !formData.subject.trim() || !formData.message.trim()}
                >
                  {loading ? (
                    <>Sending...</>
                  ) : (
                    <>
                      Send Message
                    </>
                  )}
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default Help;